module.exports = __webpack_public_path__ + "img/Czechia_GP1_CI_Podnikave-zeny_1920x654px-02.80b5ab7b.png";